var _rect, _line, _line2, _polyline, _circle, _circle2, _circle3, _circle4, _circle5, _text, _text2, _text3, _text4, _text5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSensorsDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    stroke: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 260,
    height: 260,
    rx: 20,
    fill: "#fff",
    stroke: "#333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 250,
    x2: 250,
    y2: 250,
    stroke: "#333"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 250,
    x2: 50,
    y2: 50,
    stroke: "#333"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "50,220 100,180 150,130 200,170 250,90",
    fill: "none",
    stroke: "#ff5722",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 220,
    r: 6,
    fill: "#ff5722",
    stroke: "#333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 180,
    r: 6,
    fill: "#ff5722",
    stroke: "#333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 130,
    r: 6,
    fill: "#ff5722",
    stroke: "#333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 170,
    r: 6,
    fill: "#ff5722",
    stroke: "#333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 90,
    r: 6,
    fill: "#ff5722",
    stroke: "#333"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 265,
    fontSize: 14,
    fill: "#333"
  }, "0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 265,
    fontSize: 14,
    fill: "#333"
  }, "1")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 265,
    fontSize: 14,
    fill: "#333"
  }, "2")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 265,
    fontSize: 14,
    fill: "#333"
  }, "3")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 265,
    fontSize: 14,
    fill: "#333"
  }, "4")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorsDashboard);
export default __webpack_public_path__ + "static/media/sensors-dashboard.6d0ddd1201d758eac50090bff6a99ce4.svg";
export { ForwardRef as ReactComponent };